export default __webpack_public_path__ + "static/media/scoreRating_pass_bg.3af1dd34.png";